"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var reports;
        (function (reports) {
            var index;
            (function (index) {
                class InitArgs {
                    constructor() {
                        this.reportsIndex = appn.emptyString;
                    }
                }
                let _initArgs;
                let _dataTable = null;
                function init(args) {
                    _initArgs = args;
                    appn.folderFilter.init(_initArgs.reportsIndex);
                    createDataTable();
                }
                index.init = init;
                function createDataTable() {
                    _dataTable = appn.dataTable.create('.dataTable', {
                        sAjaxSource: 'Reports/DataTable',
                        fnServerData: function (data) {
                            data.push({ name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value });
                        },
                        autoWidth: false,
                        aaSorting: [[1, 'asc']],
                        aoColumns: [
                            { bSortable: false, sWidth: '3%' },
                            { bSortable: true, sWidth: '60%' },
                            { bSortable: true, sWidth: '20%' },
                            { bSortable: true, sWidth: '17%' }
                        ],
                        fnInitComplete: function () {
                            appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                            appn.dataTable.addSearchPlaceholder(T('Filter results where the Reports <b>Name or Type</b> contains a keyword typed in here.'));
                        }
                    });
                }
            })(index = reports.index || (reports.index = {}));
        })(reports = views.reports || (views.reports = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
